// UTILS
// -----------------------------------

export function mapLocaleToCountry(locale) {
  switch (locale) {
    case "ca":
      return "es-ca";
    case "eu":
      return "es-eu";
    case "en":
      return "gb";
    case "du":
      return "nl";
    case "ko":
      return "kr";
    case "da":
      return "dk";
    case "zh":
      return "cn";
    default:
      return locale;
  }
}

export function getLocaleCountryMap({ locales }) {
  return (
    locales &&
    locales.reduce((prev, locale) => {
      prev[locale] = mapLocaleToCountry(locale);
      return prev;
    }, {})
  );
}

export function getTranslationByLocale({ translations, locale, localeProperty = "locale" }) {
  if (translations && translations.length > 0) {
    return translations.find(translation => translation[localeProperty] === locale) || null;
  }
  return null;
}
function isEmpty(value) {
  return !(value !== null && typeof value !== "undefined");
}
export function entityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  /*
    if (!entity || Object.keys(entity).length === 0) {
        return {};
    }
    */
  // extract each field value from entity directly
  const formValues = fields.reduce((result, field) => {
    if (!field.translated) {
      let newValue = "";
      if (!isEmpty(entity[field.fieldName])) {
        newValue = entity[field.fieldName];
      } else if (!isEmpty(field.defaultValue)) {
        newValue = field.defaultValue;
      }
      result[field.fieldName] = newValue;
    }

    return result;
  }, {});

  // check if this form / entity must handle translations and return the corresponding form values
  // organized by locale
  if (translationConfig && translationConfig.translated) {
    // get property in entity where translations are held according to the translation configuration
    const entityTranslations = entity[translationConfig.entityProperty];
    // assign the corresponding translated values in a specific field
    formValues[translationConfig.fieldName] =
      locales &&
      locales.map(locale => {
        const translation =
          getTranslationByLocale({
            translations: entityTranslations,
            locale,
            localeProperty: translationConfig.localeProperty,
          }) || {};
        const translatedFormValues = fields.reduce((result, field) => {
          if (field.translated) {
            result[field.fieldName] =
              translation[field.fieldName] ||
              (field.defaultValue && field.defaultValue[locale]) ||
              "";
          }
          return result;
        }, {});
        return { locale, ...translatedFormValues };
      }, {});
  }
  return formValues;
}

export function secondsToMilliseconds(seconds) {
  return seconds * 1000;
}

export function getPercentage(value) {
  if (!value) {
    return `0%`;
  }
  const fixedValue = (value * 100).toFixed(2);
  return fixedValue % 1 === 0 ? `${(value * 100).toFixed(0)}%` : `${fixedValue}%`;
}
